import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from "@angular/http";

import 'rxjs/add/operator/toPromise';

export class Vote {

  public id: number = 0;
  public post_id: number = 0;
  public post_title: string = '';
  public post_permalink: string = '';
  public value: number = 0;
  public code: string = '';
  public created_at: number = 0;

}

@Injectable()
export class VoteService {

  private apiUrl;

  private headers;

  constructor(private http: Http) {
    this.apiUrl = document.getElementById('wp-feedback-suite-container').dataset.apiUrl + 'feedback-suite/v1/';

    if (document.getElementById('wp-feedback-suite-container').dataset.apiNonce) {
      console.log('Nonce is present');

      this.headers = new Headers({
        'Content-Type': 'application/json',
        'X-WP-NONCE': document.getElementById('wp-feedback-suite-container').dataset.apiNonce
      });
    } else {
      console.log('Nonce is missing');
    }
  }

  getVotes(): Promise<Vote[]> {

    return this.http.get(this.apiUrl + 'article-feedback/votes', this.getOptions())
        .toPromise()
        .then(response => response.json() as Vote[])
        .catch(this.handleError);
  }

  private getOptions() {
    return new RequestOptions({headers: this.headers});
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// ./src/app/service/vote.service.ts